import Repre from '~/scripts/services/model/repre';
import NoteComment from '~/scripts/services/model/note-comment';
import NoteContext from '~/scripts/services/model/note-context';
import APIV5 from '~/models/api';

/* globals Knitiv */

export default class CommentsController {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} NodeService
	 * @param {any} Notification
	 * @param {any} User
	 */
	constructor(
		$rootScope,
		$scope,
		$translate,
		NodeService,
		Notification,
		User,
	) {
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$translate = $translate;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.User = User;

		this.defaultOptions = {
			showTypes:   true,
			defaultType: null,
		};

		/** @type {boolean} */
		this.disabled = false;

		/** @type {boolean} */
		this.displayEditor = false;

		/** @type {import('~/components/kform/kform.controller').default | undefined} */
		this.kformCtrl = undefined;

		/** @type {NoteContext[]} */
		this.contexts = [];

		/**
		 * @type {{
		 *   kid: import('@knitiv/api-client-javascript').KNode,
		 *   isa: import('@knitiv/api-client-javascript').KNode
		 * } | undefined}
		 */
		this.node = undefined;

		/** @type {import('~/scripts/services/model/node')[]} */
		this.noteTypes = [];

		/** @type {NoteContext}} */
		this.tmpContext = new NoteContext();

		/** @type {boolean} */
		this.tmpOpened = true;
	}

	async createNote() {
		const nodeNote = this.NodeService.create('K_NODE;KNOTE');
		nodeNote.setRepre([
			new Repre(),
		]);
	}

	/**
	 * @param {number} k
	 */
	deleteContext(k) {
		this.contexts.splice(k, 1);
		if (this.contexts.length === 0) {
			this.tmpOpened = true;
		}
	}

	async load() {
		if (this.node?.kid) {
			this.tmpContext.affectedTo = [{
				class_kid: this.node.isa,
				kid:       this.node.kid,
			}];
			const nodeContextsResult = await APIV5.instance.kNote.nodeFetch({
				data: {
					node_kid: this.node.kid,
				},
			}, {
				id:              'comments.init',
				endpointVersion: 3,
			});
			if (nodeContextsResult?.contexts.length > 0) {
				this.contexts = nodeContextsResult.contexts.map((/** @type {any} */ context) => new NoteContext(context));
			}
			else {
				this.contexts.length = 0;
			}
		}
		else {
			this.tmpContext.affectedTo.length = 0;
		}
	}

	reset() {
		const newComment = new NoteComment({
			author: this.$rootScope.context?.profil.kid,
		});
		newComment.edit();

		// this.tmpContext.addNote(newComment);
		if (this.node?.kid) {
			this.tmpContext.affectedTo = [{
				class_kid: this.node.isa,
				kid:       this.node.kid,
			}];
		}
		this.tmpContext.kid = undefined;
		this.tmpContext.type = this.options.defaultType;
		this.tmpContext.owner = this.$rootScope.context?.profil.kid;
	}

	$onInit() {
		// this.options = {
		// 	...this.defaultOptions,
		// 	...this.options,
		// };

		// check options
		if (this.options.showTypes === false && !this.options.defaultType) {
			throw new Error('options.defaultType cannot be empty if options.showTypes is false');
		}

		(async () => {
			this.noteTypes = await this.NodeService.list('K_NODE;KNOTETYPE');
		})();

		this.$scope.$watch('$ctrl.options', () => {
			this.options = {
				...this.defaultOptions,
				...this.options,
			};
			this.reset();
		}, true);
		this.reset();

		this.$scope.$watch('$ctrl.node', async () => {
			this.contexts.map(c => ({ ...c, affectedTo: this.node }));
			await this.load();
		}, true);
	}
}
